import { CallbackObject } from 'api/core/get-page-function';
import { GetSuppliersVm } from './get-suppliers.vm';
import { AxiosResponse } from 'axios';
import { instance } from 'api/core';
import { plainToClass } from 'class-transformer';

export const getSuppliers = async (offset: string, term: string, callback: CallbackObject<GetSuppliersVm>) => {
  const config: Record<string, any> = {
    headers: {
      'Content-Type': 'application/json',
    },
    params: {
      limit: 50,
      offset: offset,
    },
  };

  if (term && term.length > 2) {
    config.params.term = term;
  }

  try {
    const res: AxiosResponse = await instance.get(`/reception/suppliers`, config);
    callback.success(plainToClass(GetSuppliersVm, res.data));
  } catch (err) {
    if (callback.error) callback.error(err);
  }
};
